import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { map } from 'rxjs/operators';
import { LoadplanningService } from '../../services/loadplanning.service';
import { ShoppingCartService } from '../../services/shoppingcart.service';

@Component({
  selector: 'app-loadplanning-dialog',
  templateUrl: './loadplanning-dialog.component.html',
  styleUrls: ['./loadplanning-dialog.component.scss']
})
export class LoadplanningDialogComponent implements OnInit {

  planningTable$ = this.loadplanningService.loadPlanning$.pipe(
    map(planning => {
      const rows = planning?.extras?.rows.split('\n');
      if (!rows) {
        return [];
      }
      const splitRows = rows.map(row => row.split('|'));
      const polishedRows = splitRows
        .map(row => row
          .filter(value => !!value)
          .reverse()
          .map(value => value.trim())
          .map(value => ({ value, selected: value.startsWith('EXT'), empty: !value })));
      return polishedRows;
    })
  );

  constructor(
    public loadplanningService: LoadplanningService,
    public shoppingCartService: ShoppingCartService,
    public dialogRef: MatDialogRef<LoadplanningDialogComponent>
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

}
